// Shared grid template used by both the per-section header row and each `PageRow`,
// so that headers always line up with their cells. The page-title column flexes to fill the
// remaining width; all other columns are fixed widths per design.
//
// Template sections only show Page Title / Page Type / Points; all other columns
// (due date, locked, released) are hidden.
//
// Class strings are written out in full so Tailwind's JIT picks them up.
// The Page Title column has a 200px floor so it stays readable on mobile; the
// `min-w-*` on the grid then keeps the row at design widths and lets the
// parent `ScrollableTableContainer` trigger horizontal scroll instead of
// squishing cells.
const FULL_GRID_CLASS =
  "grid grid-cols-[minmax(200px,1fr)_180px_130px_180px_60px_240px] items-center gap-3 px-3 min-w-[1080px]";
const TEMPLATE_GRID_CLASS =
  "grid grid-cols-[minmax(200px,1fr)_180px_150px] items-center gap-3 px-3 min-w-[600px]";

export const getPageGridClass = (isInTemplateSection: boolean) =>
  isInTemplateSection ? TEMPLATE_GRID_CLASS : FULL_GRID_CLASS;

export const HEADER_LABEL_CLASS = "text-xs font-medium text-black-tint-20";
